import { useNavigate, useParams } from 'react-router-dom';
import PrettyLoader from '../components/PrettyLoader';
import ProductBigComponent from '../components/ProductBigComponent';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import { useWish } from '../hooks/useWish';

const MyWishPage = () => {
  const { wishId } = useParams();
  const navigate = useNavigate();
  const query = useWish(wishId);

  return (
    <div style={{ margin: '2rem' }} className="space-y-4">
      <Breadcrumbs
        crumbs={[
          { text: 'Meine Wünsche', route: `/my-wishes` },
          { text: 'Dieser Wunsch', route: `/my-wish/${wishId}` },
        ]}
      />
      <PrettyLoader useQueryResult={query}>
        {query.data && <ProductBigComponent product={query.data} onEdit={() => navigate(`/edit-wish/${wishId}`)} />}
      </PrettyLoader>
    </div>
  );
};

export default MyWishPage;
